import React from 'react'
import UserService from '../../store/services/UserService'
import { Navigate, useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { getCurrentUser } from '../../store/redux/reducers/currentUserSlice'
import { hasRole } from '../../store/utils'
import PageContainer from '../Page/PageContainer'
import LoadingUserDataView from '../../views/LoadingUserDataView/LoadingUserDataView'
import { RoleName } from '../../store/types/enums/RoleType'

type RouteGuardProps = {
  allowedRoles: RoleName[]
}

const RouteGuard = ({ allowedRoles }: RouteGuardProps) => {
  const isLoggedIn = UserService.isLoggedIn()
  const location = useLocation()
  const currentUser = useSelector(getCurrentUser)

  const to = location.pathname

  if (!isLoggedIn) return <Navigate to="/login" state={{ from: location }} replace />

  if (currentUser?.roles === undefined) return <LoadingUserDataView to={to} />

  if (hasRole(allowedRoles, currentUser?.roles)) {
    return <PageContainer />
  }

  return <Navigate to="/unauthorized" />
}

export default RouteGuard
